import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import noop from '../../../lib/noop';
import BuyerFields from './BuyerFields';

function BuyerFieldsContainer(props) {
  return (
    <BuyerFields
      {...props}
      onFilled={values => {
        const { mutate, event, language } = props;

        mutate({
          mutation: createLead,
          variables: { input: { ...values, language, eventId: event.id, source: 'registerForm' } },
        }).catch(noop);
      }}
    />
  );
}

BuyerFieldsContainer.propTypes = {
  mutate: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
};

const createLead = gql`
  mutation createLead($input: LeadInput!) {
    createLead(input: $input) {
      id
    }
  }
`;

export default graphql(createLead)(BuyerFieldsContainer);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/OrderForm/BuyerFields/BuyerFieldsContainer.js